export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  DB_DIAGRAM: "/dbdiagram",
  ASK_FLASHDICE: "/ask-flashdice",
  COLLABORATION: "/collaboration/:channel_code",
  SAVED_LIST: "/saved-queries",
  FILE_UPLOAD: "/fileupload",
  ROLES: "/roles",
  USERMANAGEMENT: "/user-management",
  REVIEW_SQL: "/review-sql",
  BUSINESS_DEFINITION: "/business-definition",
  UNAUTHORIZED: "/unauthorized"
};

export const DRAWER_WIDTH = 240;

export const SOCKET_EVENTS = {
  // Static Events (used with payload containing channel_code)
  JOIN: "join",
  LEAVE: "leave",
  DISCONNECT: "disconnect",
  
  // Global Collaboration Events
  JOIN_COLLABORATION: "join_collaboration",
  LEAVE_COLLABORATION: "leave_collaboration",
  GLOBAL_USER_ONLINE: "global_user_online",
  GLOBAL_USER_OFFLINE: "global_user_offline",
  GLOBAL_USER_LIST: "global_user_list",

  // Dynamic Event Name Helpers (per channel)
  MESSAGE: (channelCode) => `message_${channelCode}`,
  TYPING: (channelCode) => `typing_${channelCode}`,
  USER_LIST: (channelCode) => `user_list_${channelCode}`,
  USER_JOINED: (channelCode) => `user_joined_${channelCode}`,
  USER_LEFT: (channelCode) => `user_left_${channelCode}`
};
